import { Fragment, memo, useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { PmiHeadTableCell } from 'shell/components/shared/table-custom/head';
import CardRow from './table-row';
import { DocumentSerieItemVM } from 'civil-status/view-models/document-serie-list';

export interface TableIdCardComponentProps {
  items: Array<DocumentSerieItemVM>;
  onTrashPress: (item: DocumentSerieItemVM) => void;
  onVisibilityPress: (item: DocumentSerieItemVM) => void;
  onEditPress: (item: DocumentSerieItemVM) => void;
}

const TableCardComponent = ({
  items,
  onTrashPress,
  onVisibilityPress,
  onEditPress,
}: TableIdCardComponentProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const rowsPerPageOptions = [5, 10, 20, 50];

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <Fragment>
      <TableContainer>
        <Table size="medium" stickyHeader aria-label="lista soggetti">
          <TableHead>
            <TableRow>
              <PmiHeadTableCell>Codice</PmiHeadTableCell>
              <PmiHeadTableCell>Descrizione</PmiHeadTableCell>
              <PmiHeadTableCell>Azioni</PmiHeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(items || []).slice(startIndex, endIndex).map((item) => (
              <CardRow
                key={item.code}
                item={item}
                onTrashPress={onTrashPress}
                onVisibilityPress={onVisibilityPress}
                onEditPress={onEditPress}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        labelRowsPerPage="Righe per pagina:"
        count={items.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event: unknown, newPage: number) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
        }}
      />
    </Fragment>
  );
};

TableCardComponent.displayName = 'Table component';

const TableCard = memo(TableCardComponent);

export default TableCard;
